import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import LangToggle from './LangToggle';
import styles from './Footer.module.css';

const LINKS = [
  { key: 'nav.work', href: '#work' },
  { key: 'nav.services', href: '#services' },
  { key: 'nav.about', href: '#about' },
  { key: 'nav.faq', href: '#faq' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const { t, buildPath, tr } = useLang();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <p className={styles.wordmark}>EDELNAD</p>
            <p className={styles.motto}>moving images</p>
            <p className={styles.location}>
              {tr('Berlin, Germany · On the road often', 'Berlin, Deutschland · Oft unterwegs')}
            </p>
          </div>

          <nav className={styles.nav} aria-label="Footer navigation">
            {LINKS.map((link) => (
              <a key={link.href} href={link.href} className={styles.navLink}>
                {t(link.key)}
              </a>
            ))}
          </nav>

          <div className={styles.contact}>
            <a href="#contact" className={styles.email}>
              {t('footer.startProject')}
            </a>
            <p className={styles.contactNote}>
              {tr('Planning an event? Talk to us early.', 'Ein Event in Planung? Sprechen Sie früh mit uns.')}
            </p>
          </div>
        </div>

        <div className={styles.legalRow}>
          <p className={styles.copyright}>
            © {year} EDELNAD Productions. {tr('All rights reserved.', 'Alle Rechte vorbehalten.')} · edelnad.com
          </p>
          <div className={styles.legalRight}>
            <p className={styles.legalLinks}>
              <Link to={buildPath('/impressum')}>{t('footer.impressum')}</Link>
              <span aria-hidden="true">·</span>
              <Link to={buildPath('/datenschutz')}>{t('footer.datenschutz')}</Link>
            </p>
            <div className={styles.footerLang}>
              <LangToggle />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
